import React, { useEffect, useState } from 'react'
import { Grid } from '@material-ui/core'

import MetricCard from 'react-metric-card'
import 'react-metric-card/dist/index.css'
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm'
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import ImportantTable from './survey11'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import Button from 'react-bootstrap/Button';


import NewPatientModal from './NewPatientModal.jsx'
import NewPatientModal2 from './NewPatientModal2.jsx'





const Dmedashboard = () => {


    const OpenModalButton = () => {
      const [open, setOpen] = React.useState(false);
    
      const handleOpen = () => {
        setOpen(true);
      };
    
      const handleClose = () => {
        setOpen(false);
      };


      return (
        <>
        <div >
        <button onClick={handleOpen} class="bg-transparent hover:bg-green-500 text-green-700 font-semibold hover:text-white py-2 px-4 border border-green-500 hover:border-transparent rounded">
  Add Property
</button>
        </div>
        

          <NewPatientModal2
            open={open}
            onOpen={handleOpen}
            onClose={handleClose}
          />
        </>
      );
    };
  

  return (

    <div className='App'>
  
    
      
      <div style={{ float: 'right', marginTop: -78, marginRight: 0, display: 'flex', 
      }}>


       <OpenModalButton/> 

       


      </div>
      
      
     
      <br />
      <br />
      <br />
      
      

      <div style={{display:'flex', flexDirection:'row', display: 'flex', marginTop:'-40px' }} >
 <ImportantTable />    
    


</div>
{/* <FitterMap />  */}
    </div>
  )
    



  
    
}


export default Dmedashboard